import React from 'react'

export type TabPanelProps = {
  value: number
  index: number
}

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (props) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        transition: 'opacity 0.3s ease-out',
        opacity: value === index ? 1 : 0,
        height: '100%',
        overflow: 'hidden'
      }}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  )
}
